<template>
  <v-list-group active-class="primary white--text" :value="false">
    <template v-slot:activator>
      <v-list-item-icon class="mr-4">
        <v-badge v-if="$app.hasUnreadMessage" dot overlap color="red">
          <v-icon>mdi-library</v-icon>
        </v-badge>
        <v-icon v-else>mdi-library</v-icon>
      </v-list-item-icon>
      <v-list-item-title>Chủ nhiệm</v-list-item-title>
    </template>
    <v-list class="py-0">
      <v-list-item class="px-0" active-class="blue lighten-4 primary--text" link to="/classes">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title>Danh sách lớp</v-list-item-title>
      </v-list-item>
      <v-list-item active-class="blue lighten-4 primary--text" class="px-0" link to="/attendances">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title>Chuyên cần</v-list-item-title>
      </v-list-item>
      <v-list-item class="px-0" active-class="blue lighten-4 primary--text" link to="/complimented">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title>Khen thưởng kỷ luật</v-list-item-title>
      </v-list-item>
      <!-- <v-list-item active-class="blue lighten-4 primary--text" class="px-0" link to="/student-mark"> -->
      <v-list-item active-class="blue lighten-4 primary--text" class="px-0" link to="/marks">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title>Sổ điểm</v-list-item-title>
      </v-list-item>
      <!-- Gửi tin tự động -->
      <v-list-item
        class="px-0"
        active-class="blue lighten-4 primary--text"
        link
        to="/head-contact-book"
      >
        <v-list-item-action></v-list-item-action>
        <v-list-item-title>Tin tự động SLLĐT</v-list-item-title>
      </v-list-item>
      <v-list-item active-class="blue lighten-4 primary--text" class="px-0" link to="/ownClassTimeTable">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title>Thời khóa biểu</v-list-item-title>
      </v-list-item>
      <v-list-item
        v-if="$auth.policies['view-period-list']"
        active-class="blue lighten-4 primary--text"
        class="px-0"
        link
        to="/tuition-fee-period"
      >
        <v-list-item-action></v-list-item-action>
        <v-list-item-title>Thu/đóng học phí</v-list-item-title>
      </v-list-item>
      <v-list-item active-class="blue lighten-4 primary--text" class="px-0" link to="/feedback">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title v-if="$app.hasUnreadMessage">
          <div class="d-flex justify-space-between">
            Phản hồi
            <v-icon size="12" class="mr-6" color="red">mdi-circle</v-icon>
          </div>
        </v-list-item-title>

        <v-list-item-title v-else>Phản hồi</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-list-group>
</template>

<script>
export default {}
</script>
